// extracted by mini-css-extract-plugin
export default {"challengeForm":"ChallengeForm_challengeForm__X-1Oh"};